<nav class="navbar navbar-expand-lg navbar-light bg-light mb-4">
  <a class="navbar-brand">{{pageTitle}}</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <a class="nav-link" routerLink="/home">Home</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/contact">Contact</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/faq">FAQ</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/forms">Forms</a>
      </li>
    </ul>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <a class="nav-link" routerLink="/login">Welcome {{userName}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="logOut()" style="cursor: pointer">Log Out</a>
      </li>
    </ul>
  </div>
</nav>
